import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Vehicle } from 'src/app/core/models/vehicle';
import { VehicleForm } from 'src/app/core/models/vehicleForm';

@Component({
  selector: 'app-save-and-edit',
  templateUrl: './save-and-edit.component.html',
  styleUrl: './save-and-edit.component.scss'
})
export class SaveAndEditComponent {
  @Input() visible = false;
  @Input() editingVehicle: Vehicle | null = null;
  @Input() categoryLabel = 'Veículo';
  @Input() showTypeSelect = false;
  @Input() vehicleTypes: any[] = [];

  // Dados dos dropdowns vindos do pai
  @Input() marcas: any[] = [];
  @Input() modelos: any[] = [];
  @Input() anos: any[] = [];
  @Input() versoes: any[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<VehicleForm>();

  // Eventos para pedir dados ao pai
  @Output() typeChanged = new EventEmitter<void>();
  @Output() brandChanged = new EventEmitter<any>(); // envia a marca selecionada
  @Output() modelChanged = new EventEmitter<any>(); // envia o modelo selecionado
  @Output() yearChanged = new EventEmitter<any>();  // envia o ano selecionado
  @Output() versionChanged = new EventEmitter<any>();  // envia o ano selecionado

  form: VehicleForm = this.getEmptyForm();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      if (this.editingVehicle) {
        this.fillForm(this.editingVehicle);
      } else {
        this.form = this.getEmptyForm();
      }
    }
  }

  getEmptyForm(): VehicleForm {
    return {
      tipo: '', // Será preenchido pelo pai ou dropdown
      marca: null, modelo: null, ano: null, versao: null,
      placa: '', cor: '', quilometragem: null, observacoes: '',
      isPrimary: false
    };
  }

  fillForm(vehicle: Vehicle) {
    this.form = {
      tipo: vehicle.tipo,
      marca: { nome: vehicle.marca, code: vehicle.marca.toLowerCase() }, // Ajuste conforme seu objeto real
      modelo: { nome: vehicle.modelo, code: vehicle.modelo.toUpperCase() },
      ano: { ano: vehicle.ano, code: vehicle.ano, nome: vehicle.ano },
      versao: { nome: vehicle.versao, code: vehicle.versao },
      placa: vehicle.placa || '',
      cor: vehicle.cor || '',
      quilometragem: vehicle.quilometragem || null,
      observacoes: vehicle.observacoes || '',
      isPrimary: vehicle.isPrimary,
      vehicle_uid: vehicle.vehicle_uid,
    };
    // Importante: Ao abrir edição, talvez precise disparar eventos para carregar listas
    // mas depende se os objetos marca/modelo já vem completos do backend
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  save() {
    if (this.isFormValid()) {
      this.onSave.emit(this.form);
    }
  }

  // --- Handles de Mudança ---
  onTypeChange() {
    this.resetFields(['marca', 'modelo', 'ano', 'versao']);
    this.typeChanged.emit();
  }

  emitBrandChange() {
    this.resetFields(['modelo', 'ano', 'versao']);
    this.brandChanged.emit(this.form.marca);
  }

  emitModelChange() {
    this.resetFields(['ano', 'versao']);
    this.modelChanged.emit(this.form.modelo);
  }

  emitYearChange() {
    this.resetFields(['versao']);
    this.yearChanged.emit(this.form.ano);
  }

  emitVersionChange() {
    this.versionChanged.emit(this.form.versao);
  }

  resetFields(fields: string[]) {
    fields.forEach(f => (this.form as any)[f] = null);
  }

  // --- Utils ---
  formatPlaca(event: any): void {
    let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length > 3) {
      value = value.substring(0, 3) + '-' + value.substring(3, 7);
    }
    this.form.placa = value;
  }

  isFormValid(): boolean {
    return !!(this.form.marca && this.form.modelo && this.form.ano && this.form.versao);
  }
}
